import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Box, CircularProgress, Typography } from "@mui/material";
import axios from "axios";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

const DataGrid = ({ columnDefs, apiEndpoint, height = "500px" }) => {
  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get(apiEndpoint,{
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`
  }})
      .then((res) => setRowData(res.data))
      .catch((err) => setError("Failed to load data"))
      .finally(() => setLoading(false));
  }, [apiEndpoint]);

  return (
    <Box
      sx={{
        width: "100%",
        p: 1,
      }}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: height }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Box
          className="ag-theme-alpine"
          sx={{
            height,
            "--ag-row-height": "30px",
            "--ag-selected-row-background-color": "#E6483333",
            "--ag-row-hover-color": "#E6483333",
            "--ag-range-selection-border-color": "#E64833",
          }}
        >
          <AgGridReact
          theme="legacy"
            columnDefs={columnDefs}
            rowData={rowData}
            domLayout="normal"
            pagination={true}
            rowSelection="single"
            animateRows={true}
          />
        </Box>
      )}
    </Box>
  );
};

export default DataGrid;
